import { colors } from '../../styles/theme';
import { REFERENCE_PLACES_KIND_COLORS, REFERENCE_PLACES_PIN_STYLE } from '../styles/mapTheme';

export const REFERENCE_PLACE_ICON_PREFIX = 'ref-place-';
export const REFERENCE_PLACE_DEFAULT_KIND = 'default';

/**
 * Paths Material Outlined 24×24 (mismos glifos que el switcher).
 * `museum` trae dos paths: Path2D no comparte origen entre elementos SVG.
 */
const KIND_PATHS = {
  school: 'M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9zm6.82 6L12 12.72 5.18 9 12 5.28zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73z',
  hospital: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z',
  airport: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85',
  church: 'M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h9v-4c0-.55.45-1 1-1s1 .45 1 1v4h9v-8zM20 20h-5v-2.04c0-1.69-1.35-3.06-3-3.06s-3 1.37-3 3.06V20H4v-4.79l4-1.81v-3.35L12 8l4 2.04v3.35l4 1.81z',
  national_park: 'm24 18-3.86-6H22L15 2l-3 4.29L9 2 2 12h1.86L0 18h7v4h4v-4h2v4h4v-4zM15 5.49 18.16 10h-1.68l3.86 6h-3.62l-2.57-4H16l-2.78-3.97zM3.66 16l3.86-6H5.84L9 5.49 12.16 10h-1.68l3.86 6z',
  park: 'M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.95v-4H21zM6.79 16l3.9-6H8.88l3.13-4.5 3.15 4.5h-1.9l4 6z',
  police: 'm14.5 12.59.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34zM12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3zM12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5z',
  prison: 'M1 21h12v2H1zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31z',
  library: 'M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55m7 5.58c-2.53.34-4.93 1.3-7 2.82-2.06-1.52-4.47-2.49-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27c1.59-1.48 3.54-2.45 5.64-2.83z',
  museum: [
    'M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9zm-4 9H6V9h12z',
    'M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z',
  ],
  monument: 'M6.5 10h-2v7h2zm6 0h-2v7h2zm8.5 9H2v2h19zm-2.5-9h-2v7h2zm-7-6.74L16.71 6H6.29zm0-2.26L2 6v2h19V6z',
  cultural_org: 'M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67 0 1.38-1.12 2.5-2.5 2.5m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7',
  sports: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 3.3 1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34M7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54zm3.79 2.21-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21',
  gym: 'M20.57 14.86 22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z',
  supermarket: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2m-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM6.16 6h12.15l-2.76 5H8.53z',
  mall: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3m7 17H5V8h14zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3',
  landfill: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z',
  default: 'M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14M12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2',
};

export const REFERENCE_PLACE_ICON_KINDS = Object.keys(KIND_PATHS)
  .filter((kind) => kind !== REFERENCE_PLACE_DEFAULT_KIND);

function kindPathList(kind) {
  const value = KIND_PATHS[kind] || KIND_PATHS[REFERENCE_PLACE_DEFAULT_KIND];
  return Array.isArray(value) ? value : [value];
}

/**
 * @param {string} kind
 * @returns {string}
 */
export function resolveReferencePlaceKind(kind) {
  const key = String(kind || '').trim();
  if (key && Object.prototype.hasOwnProperty.call(KIND_PATHS, key)) return key;
  return REFERENCE_PLACE_DEFAULT_KIND;
}

/**
 * @param {string} kind
 * @returns {string}
 */
export function referencePlaceIconImageId(kind) {
  return `${REFERENCE_PLACE_ICON_PREFIX}${resolveReferencePlaceKind(kind)}`;
}

/**
 * Color de badge / pin para un kind. Fallback al pin genérico.
 *
 * @param {string} kind
 * @returns {string}
 */
export function getReferencePlaceKindColor(kind) {
  const resolved = resolveReferencePlaceKind(kind);
  return REFERENCE_PLACES_KIND_COLORS[resolved] || REFERENCE_PLACES_KIND_COLORS.default;
}

function renderKindBadgeImageData(kind) {
  const { iconPixelSize: size, iconPixelRatio } = REFERENCE_PLACES_PIN_STYLE;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  const cx = size / 2;
  const cy = size / 2;
  const radius = size / 2 - 3;

  ctx.clearRect(0, 0, size, size);
  ctx.shadowColor = 'rgba(0,0,0,0.28)';
  ctx.shadowBlur = 4;
  ctx.shadowOffsetY = 1;

  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  ctx.fillStyle = getReferencePlaceKindColor(kind);
  ctx.fill();

  ctx.shadowColor = 'transparent';
  ctx.lineWidth = 3;
  ctx.strokeStyle = REFERENCE_PLACES_PIN_STYLE.strokeColor;
  ctx.stroke();

  const iconSize = size * 0.48;
  ctx.save();
  ctx.translate(cx - iconSize / 2, cy - iconSize / 2);
  ctx.scale(iconSize / 24, iconSize / 24);
  ctx.fillStyle = colors.backgroundLight;
  kindPathList(kind).forEach((d) => {
    ctx.fill(new Path2D(d));
  });
  ctx.restore();

  return {
    data: ctx.getImageData(0, 0, size, size),
    pixelRatio: iconPixelRatio,
  };
}

const KIND_IMAGE_IDS = Object.keys(KIND_PATHS).map((kind) => referencePlaceIconImageId(kind));

const mapsWithImageListeners = typeof WeakSet === 'function' ? new WeakSet() : null;
let ensureImagesInFlight = false;

/**
 * @param {object} map
 * @returns {boolean}
 */
export function referencePlaceImagesReady(map) {
  if (!map || typeof map.hasImage !== 'function') return false;
  return KIND_IMAGE_IDS.every((imageId) => {
    try { return map.hasImage(imageId); } catch { return false; }
  });
}

/**
 * Registra badges faltantes. No hace updateImage si ya están: styledata
 * dispara en cada frame y re-subir canvas rompe el placement de símbolos.
 *
 * @param {object} map
 * @returns {{ added: number, ready: boolean }}
 */
export function ensureReferencePlaceImages(map) {
  if (!map || typeof map.addImage !== 'function' || typeof document === 'undefined') {
    return { added: 0, ready: false };
  }
  if (ensureImagesInFlight) {
    return { added: 0, ready: referencePlaceImagesReady(map) };
  }
  if (referencePlaceImagesReady(map)) return { added: 0, ready: true };

  ensureImagesInFlight = true;
  let added = 0;
  try {
    KIND_IMAGE_IDS.forEach((imageId) => {
      try {
        if (map.hasImage(imageId)) return;
      } catch {
        return;
      }
      const kind = imageId.slice(REFERENCE_PLACE_ICON_PREFIX.length);
      const rendered = renderKindBadgeImageData(kind);
      if (!rendered) return;
      try {
        map.addImage(imageId, rendered.data, { pixelRatio: rendered.pixelRatio });
        added += 1;
      } catch {
        // estilo recargando
      }
    });
  } finally {
    ensureImagesInFlight = false;
  }
  return { added, ready: referencePlaceImagesReady(map) };
}

function addMissingReferencePlaceImage(map, imageId) {
  if (!map || !imageId || !imageId.startsWith(REFERENCE_PLACE_ICON_PREFIX)) return;
  try {
    if (map.hasImage(imageId)) return;
  } catch {
    return;
  }
  const kind = imageId.slice(REFERENCE_PLACE_ICON_PREFIX.length);
  const rendered = renderKindBadgeImageData(kind);
  if (!rendered) return;
  try {
    map.addImage(imageId, rendered.data, { pixelRatio: rendered.pixelRatio });
  } catch {
    // estilo recargando
  }
}

/**
 * Completa badges cuando el estilo pide un ícono. No enganchar `idle`:
 * addImage dispara otro idle y satura el mapa + reportclienterror (429).
 *
 * @param {object} map
 */
export function bindReferencePlaceImages(map) {
  if (!map || typeof map.on !== 'function') return;
  if (mapsWithImageListeners && mapsWithImageListeners.has(map)) {
    ensureReferencePlaceImages(map);
    return;
  }
  if (mapsWithImageListeners) mapsWithImageListeners.add(map);

  try {
    map.on('styleimagemissing', (event) => {
      addMissingReferencePlaceImage(map, String(event?.id || ''));
    });
  } catch (_) {
    // mapa destruyéndose
  }
  ensureReferencePlaceImages(map);
}
